var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex bg-black text-white flex-col min-h-screen overflow-hidden"},[_c('main',{staticClass:"flex-grow"},[_c('HeroHome'),_c('Demo')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }